<script setup>
  defineOptions({name: "PagesOnboarding"});
</script>

<template>
  <div id="bg-login" class="-mx-4 -mb-4 flex flex-1 grow bg-cover bg-top">
    <!-- just a background image and the crypt dialog -->
  </div>
</template>
